import { render, staticRenderFns } from "./confirmacionAlta.vue?vue&type=template&id=5f3cc7a6&"
import script from "./confirmacionAlta.vue?vue&type=script&lang=js&"
export * from "./confirmacionAlta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports